import { render, staticRenderFns } from "./NewsletterEditor.vue?vue&type=template&id=4a7f485f&"
import script from "./NewsletterEditor.vue?vue&type=script&lang=js&"
export * from "./NewsletterEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports